module.exports = __webpack_public_path__ + "img/dryva-screen-8.4f74af47.png";